import defaultSchema from './default.schema';
import partner from './partner.schema';

export default {
  ...defaultSchema,
  title: 'partner registration',
  type: 'object',
  properties: {
    login: {
      type: 'string',
      title: 'Nazwa użytkownika',
      format: 'email',
      calc: '$root.partner.email',
      validationMessages: {
        format: 'Login użytkownika musi być adresem e-mail'
      }
    },
    profile: {
      title: 'profile',
      type: 'object',
      properties: {
        type: {
          title: 'Typ konta',
          type: 'number'
        },
        firstName: {
          title: 'Imię użytkownika',
          type: 'string'
        },
        lastName: {
          title: 'Nazwisko użytkownika',
          type: 'string'
        },
        email: {
          title: 'Adres e-mail',
          type: 'string',
          format: 'email',
          calc: '$root.partner.email',
          validationMessages: {
            format: 'Niepoprawny adres e-mail'
          }
        }
      }
    },
    partner
  }
};
